<!-- Button trigger modal -->
<div style="text-align: center; margin-top: 10px;">
    <button *ngIf="contractData && role == 'admin'" [disabled]="!contractData.active" type="button" class="btn btn-danger" data-toggle="modal" aria-label="Left Align" data-target="#cancelContractModal">
        <span *ngIf="contractData.active">
            Cancelar contrato
        </span>
        <span *ngIf="!contractData.active">
            Contrato Cancelado
        </span>
        
    </button>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="cancelContractModal" tabindex="-1" role="dialog" aria-labelledby="cancelContractModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="cancelContractModalLabel">Cancelar Contrato</h5>
                <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="contractData">
                <p>Está seleccionando cancelar el contrato #<strong>{{ contractData.id }}</strong></p>
                <p>Para confirmar esto, seleccione cancelar nuevamente.</p>
            </div>
            <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
                Error intente luego...
            </div>
            <div class="modal-footer">
            
                <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="button" (click)="cancelContract()" class="btn btn-danger">Cancelar</button>
            </div>
       
        </div>
    </div>
    </div>